import React from "react";
import { useStore } from "./Context";

function WithConsumer(WrappedComponent) {
    return function WithConsumerWrapper(props) {
        const context = useStore();
        
        return <WrappedComponent {...props} context={context} />;
    };
}

export default WithConsumer;